import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PUBLIC_PATHS = ["/login", "/register"];

const AuthGate = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div style={{ textAlign: "center", padding: "60px", fontSize: "16px" }}>
                Loading...
            </div>
        );
    }

    const isPublicPath = PUBLIC_PATHS.includes(location.pathname);

    // Not logged in, trying to access a protected page → send to login
    if (!user && !isPublicPath) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    // Already logged in, trying to visit login/register → send to home
    if (user && isPublicPath) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AuthGate;